"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InterviewerHarnessType", {
    enumerable: true,
    get: function() {
        return InterviewerHarnessType;
    }
});
const _zod = require("zod");
const InterviewerHarnessType = _zod.z.enum([
    "competency",
    "reporting_analytics_report"
]);
